module.exports = __webpack_public_path__ + "static/ginger-23f84eb3083b5a5225c5b5360322a92c.png";